/* __next_internal_client_entry_do_not_use__ Arrow auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import styled from "styled-components";
import { SVGIcon } from "../SVGIcon";
var DirectionalIcon = styled(SVGIcon).withConfig({
    componentId: "sc-3a5d8e15-0"
})([
    "transform:rotateZ( ",
    " );"
], function(param) {
    var direction = param.direction;
    switch(direction){
        case "right":
            return "0deg";
        case "down":
            return "90deg";
        case "left":
            return "180deg";
        case "upAndRight":
            return "315deg";
        case "up":
        default:
            return "270deg";
    }
});
// Wrapping for better alignment with rotated versions
var RotationalContainer = styled.div.withConfig({
    componentId: "sc-3a5d8e15-1"
})([
    "overflow:hidden;display:flex;"
]);
export var Arrow = /*#__PURE__*/ React.memo(/*#__PURE__*/ React.forwardRef(function(_param, ref) {
    var direction = _param.direction, props = _object_without_properties(_param, [
        "direction"
    ]);
    return /*#__PURE__*/ _jsx(RotationalContainer, {
        children: /*#__PURE__*/ _jsxs(DirectionalIcon, _object_spread_props(_object_spread({
            direction: direction,
            viewBox: "0 0 24 24",
            fill: "none",
            ref: ref
        }, props), {
            children: [
                /*#__PURE__*/ _jsx("path", {
                    d: "M0.856934 12H23.1426",
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M17.1426 18L23.1426 12L17.1426 6",
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        }))
    });
}));
if ("production" !== "production") {
    Arrow.displayName = "ArrowIcon";
}
